module.exports = __webpack_public_path__ + "media/images/top/howto-04-1b8c4c8ae31bceae4d1dc80ca31f22a2.svg";